import {useEffect, useReducer} from "react";
import {EventEmitter2} from "./EventEmitter2";

// react binding for EventEmitter2 (the elevationTool-local emitter). Returns the
// emitter's current value and re-renders on every emit.
//
// Re-render is driven by a monotonic counter rather than useState(value): an
// emitter that re-emits a value equal to the last (e.g. frameBlocksChanged, which
// always emits `false` for a non-structural change like a corner-joint edit) would
// otherwise hit React's same-value bail-out in setState and never re-render, so the
// UI reading off the mutated model (the corner-joint buttons' active state) stays
// stale. The counter always changes, so the re-render always fires.
export function useEventEmitter2<T>(value?: EventEmitter2<T>) {
    const [, forceRender] = useReducer((x: number) => x + 1, 0);

    useEffect(() => {
        if(!value) return;

        const unsubscribe = value.subscribe(() => forceRender());
        return () => unsubscribe();
    }, [value]);

    return value?.value;
}
